import React from 'react';
import HeroImage from '../components/HeroImage';
import Navbar from '../components/Navbar';
import Work from '../components/Work';
import Footer from '../components/Footer';

const Home = () => (
  <div>
    <Navbar />
    <HeroImage />
    <Work />
    <Footer />
  </div>
);

export default Home;
